import React from 'react'
import './styles.scss'

const CtaArrow = () => (
  <span className="cta-arrow">
    <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512">
      <path d="M85 277.375h259.704L225.002 397.077 256 427l171-171L256 85l-29.922 29.924 118.626 119.701H85v42.75z" />
    </svg>
  </span>
)

export default CtaArrow
